import script from "./HrAlertDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HrAlertDialog.vue?vue&type=script&setup=true&lang=js"

import "./HrAlertDialog.vue?vue&type=style&index=0&id=2df9136c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df9136c"]])

export default __exports__